import {useMutation} from "@tanstack/react-query";

import {createSupplierFunctionMutationOptions} from "./create-supplier-function.mutation-options";

export function useCreateSupplierFunction() {
  return useMutation(createSupplierFunctionMutationOptions());
}
